export const TIMEFRAMES = ['1m', '5m', '15m', '1h', '4h', '1d'];
export const TF_SECONDS = {
    '1m': 60,
    '5m': 300,
    '15m': 900,
    '1h': 3600,
    '4h': 14400,
    '1d': 86400,
};
/** Real money: everything but demo. */
export const isRealMoney = (kind) => kind !== 'demo';
/** Every ledger entry type the database allows (see the ledger_entries CHECK constraint). */
export const LEDGER_TYPES = ['deposit', 'withdrawal', 'withdrawal_refund', 'fee', 'realized_pnl', 'swap', 'demo_reset', 'adjustment', 'credit', 'cashback', 'referral', 'yield_stake', 'yield_redeem', 'yield_interest', 'pro_transfer_out', 'pro_transfer_in', 'pro_transfer_refund', 'copy_allocate', 'copy_release', 'portfolio_allocate', 'portfolio_release', 'lead_payout', 'dividend', 'capital_return', 'chargeback', 'management_fee', 'performance_fee', 'volume_reward', 'nominal', 'trade_correction', 'rollover_adjustment', 'deposit_reversal', 'withdrawal_reversal', 'trade_transfer', 'balance_transfer', 'portfolio_exit_fee', 'portfolio_lock_bonus'];
/** Version of the demo account notice the client accepts with a request; bump it when the wording changes. */
export const DEMO_NOTICE_VERSION = '2026-10-12';
/** Why staff declined a demo account request (staff only; the client never sees it). */
export const DEMO_REQUEST_REASONS = ['start_live', 'not_suitable', 'duplicate', 'other'];
//# sourceMappingURL=types.js.map